import React, { useEffect, useState } from 'react';
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import { Modal, Form, Col } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import useAuth from "hooks/useAuth"
import 'react-phone-number-input/style.css'

import api from "assets/services/api";


function ModalUpdateSynthetics(props) {

    const [br, setBR] = useState(false);
    const [description, setDescription] = useState(props.props.description);
    const [code, setCode] = useState(props.props.code);
    const { storageId } = useAuth();
    const [controlSnack, setControlSnack] = useState(false);

    const showNotification = place => {
        switch (place) {
            case "br":
                if (!br) {
                    setBR(true);
                    setTimeout(function () {
                        setBR(false);
                        setControlSnack(false);
                    }, 6000);
                }
                break;
            default:
                break;
        }
    };

    useEffect(() => {
        if (controlSnack) showNotification("br")
    }, [controlSnack]);

    async function handleUpdateSynthetics(e) {
        e.preventDefault();
        const response = await api.put('/synthetic/' + props.props.id, {
            description: description,
            code: code
        });
        if (response.data.error) {
            return alert(response.data.error);
        }
        props.getAllSynthetics();
        props.onHide();
        setDescription("")
        setCode("")
    }


    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Editar Sintético
                </Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleUpdateSynthetics}>
                <Modal.Body>
                    <Form.Row>
                        <Form.Group as={Col} xs={2} controlId="formGridDescription">
                            <Form.Label>Descrição</Form.Label>
                            <Form.Control onChange={event => setCode(event.target.value)} value={code} type="text" placeholder="Código do Sintético" />
                        </Form.Group>
                        <Form.Group as={Col} xs={10} controlId="formGridDescription">
                            <Form.Label>Descrição</Form.Label>
                            <Form.Control onChange={event => setDescription(event.target.value)} value={description} type="text" placeholder="Código do Sintético" />
                        </Form.Group>
                    </Form.Row>
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex justify-content-center">
                        <Button color="success" type="submit">
                            Editar Sintético
                        </Button>
                        <Snackbar
                            place="br"
                            color="success"
                            icon={AddAlert}
                            message="Sintético editado com sucesso"
                            open={br}
                            closeNotification={() => setBR(false)}
                            close
                        />
                    </div>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default ModalUpdateSynthetics;